
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CallHubComponent } from '@erm//web/call-center/call/feature/hub';
import { LoaderComponent } from '@erm/web/shared/ui/loader';
import { NavComponent } from '@erm/web/shell/ui/nav';
import { NewLeadsComponent } from '@erm/web/shell/ui/new-leads';

@Component({
  imports: [
    RouterModule,
    NavComponent,
    LoaderComponent,
    CallHubComponent,
    NewLeadsComponent
],
  standalone: true,
  selector: 'app-content-layout',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './content-layout.component.html',
})
export class ContentLayoutComponent {
  constructor() {}
}
